import React, { useEffect } from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";
import "./style.css";

import Testimonials from "../Home/Testimonials";
import GetInTouch from "../Home/GetInTouch";

const GrievancePolicy = () => {
  useEffect(() => {
    document.title = "Grievance Policy";
  }, []);

  return (
    <React.Fragment>
      <div class="page_wrapper">
        <Header headerType="white_header" />

        {/* breadcrumb area start */}
        <section className="nh_breadcrumb-area">
          <div
            className="nh_breadcrumb-wrap"
            data-background="assets/images/bg/breadcrumb.webp"
          >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-7">
                  <div className="nh_breadcrumb-content text-center">
                    <h2 className="nh_breadcrumb-content-title">
                      Grievance Policy
                    </h2>
                    <div className="nh_breadcrumb-content-list">
                      <a href="/">Home</a>
                      <span>Grievance Policy</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <>
          {/* Blog Details Block */}
          <section class="float-left w-100 position-relative perfect-domain-name-con padding-top padding-bottom main-box pt-100 pb-60">
            <div class="container">
              <div className="section_title">
                <h4>Grievance Policy for FINGTEL COMMUNICATIONS</h4>

                <div className="info pt-3">
                  <p>
                    In accordance with Information Technology Act 2000 and rules
                    made there under, contact details of the Grievance Officer
                    are provided below:
                  </p>
                  {/* <p>Name:</p> */}
                  <p className="pt-2">
                    Address: FINGTEL COMMUNICATIONS, Government Primary School
                    Belwa Piparpati VILL-BELWA PIPARPANTI ,TOLA-BELWA PIPARPANTI
                    PANCH-SINGASANI Nearby Landmark: Government Primary School
                    Belwa Piparpati, BLOCK RAMGARHWA City/Town/Village:
                    Ramgarhwa District: Purbi Champaran State: Bihar PIN Code:
                    845433
                  </p>
                  {/* <p>Mobile:</p> */}
                  <p className="pt-2">Email: care@nexpe.co.in</p>
                </div>
              </div>
            </div>
          </section>
        </>

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default GrievancePolicy;
